/* Publish by EComposer at 2026-10-20 07:58:04*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-o9xpimn4j7"]=  window.__ectimmers["ecom-o9xpimn4j7"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-o9xpimn4j7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9xpimn4j7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ljtqc527l7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ljtqc527l7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ko560qdmwcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ko560qdmwcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23zq1ksyo21').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23zq1ksyo21', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-no4j1ezpfkb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-no4j1ezpfkb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vgulhdri61o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgulhdri61o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gtl9lros6nl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gtl9lros6nl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ipvcjy0rltb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ipvcjy0rltb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-akaxphxkks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-akaxphxkks', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ovvi5w9ykjn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ovvi5w9ykjn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0dgimyztoyu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0dgimyztoyu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4p0oh4imycp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4p0oh4imycp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5nt7qvdk25r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5nt7qvdk25r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-77wftslug1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-77wftslug1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b0px7jjkx5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b0px7jjkx5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xz5yxf4vkv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xz5yxf4vkv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-brm2hnxtgg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-brm2hnxtgg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fh821no80or').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fh821no80or', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5rj0yju4yua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5rj0yju4yua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4d9g5zhto').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4d9g5zhto', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8z5qekl3o4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8z5qekl3o4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4zd4xddmr8q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4zd4xddmr8q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4hve1lh3zck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4hve1lh3zck', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qzacfdhqyeb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qzacfdhqyeb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-45sfp6bm5rb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-45sfp6bm5rb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-blqrfj399ta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-blqrfj399ta', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tjamen24jv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tjamen24jv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qfzpv13mnd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qfzpv13mnd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tqnawi70pz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tqnawi70pz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2zmgyzw1xbb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2zmgyzw1xbb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ot1zg96l08q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ot1zg96l08q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wsitz6nbaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wsitz6nbaa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g2b60k0pnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g2b60k0pnm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u478v4z4kal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u478v4z4kal', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1u2z1y4gzzg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1u2z1y4gzzg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vir6fornpl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vir6fornpl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cjwwght2m1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cjwwght2m1i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dpbcq02ucwg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dpbcq02ucwg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pz9x8ehls5r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pz9x8ehls5r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7k1rhbp7tfe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7k1rhbp7tfe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ner177zeaq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ner177zeaq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbda1em3g4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbda1em3g4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4qruxi5yo87').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4qruxi5yo87', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ec2inot7ra6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ec2inot7ra6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4oew02c6xhi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4oew02c6xhi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rlxaa1jobn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rlxaa1jobn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3gqeja1qnly').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3gqeja1qnly', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzmuc29x0fh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzmuc29x0fh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vxgfseqv98m"]=  window.__ectimmers["ecom-vxgfseqv98m"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-vxgfseqv98m"]["rszfup5j9"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-vxgfseqv98m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxgfseqv98m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4s4rogz89ub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4s4rogz89ub', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3nfe54dibhs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3nfe54dibhs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6bgx54jeb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6bgx54jeb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pflgy4dmq5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pflgy4dmq5g', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jbho0n2zi4p"]=  window.__ectimmers["ecom-jbho0n2zi4p"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),s=this.settings.action;function o(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var p;(p=d.ec_splide)==null||p.refresh()})},50),r())}e.forEach((a,l)=>{s==="click"||window.screen.width<1025?a.onclick=()=>o(a,l):a.onmouseover=()=>o(a,l)});function n(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let m=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{n()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",n,!1)

                    });
                    
                        document.querySelectorAll('.ecom-jbho0n2zi4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jbho0n2zi4p', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jnkinmvjhjk"]=  window.__ectimmers["ecom-jnkinmvjhjk"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-jnkinmvjhjk"]["m75l96jkj"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-jnkinmvjhjk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jnkinmvjhjk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}